import { render, staticRenderFns } from "./AreaScores.vue?vue&type=template&id=4c131083&"
import script from "./AreaScores.vue?vue&type=script&lang=ts&"
export * from "./AreaScores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports